import React from "react"
import { graphql } from "gatsby"
// import Styles from "./CategoryPageTemplate.module.scss"
import SkuGrid from "../Skus/SkuGrid"
import CategoryPageHero from "./CategoryPageHero"
export default ({ data }) => {
  const { name, products, categoryImage } = data.contentfulCategories

  return (
    <>
      {console.log(data.contentfulCategories)}
      <CategoryPageHero title={name} image={categoryImage.fluid.src} />
      <SkuGrid Skus={products} />
    </>
  )
}

export const query = graphql`
  query($name: String!) {
    contentfulCategories(name: { eq: $name }) {
      id
      name
      products {
        id
        name
        price
        shortDescription
        images {
          description
          fluid(maxWidth: 400, maxHeight: 400) {
            ...GatsbyContentfulFluid
          }
        }
        sizes {
          size
        }
      }
      categoryImage {
        fluid {
          src
        }
      }
    }
  }
`
